import { defineNuxtPlugin } from '#app/nuxt'
import { LazyPageTitle, LazyUTable, LazyFaq, LazyUBanner, LazyUHighlight, LazyUSummaryCard, LazyUVideo, LazyCompoundCalculator, LazyPensionCalculator, LazyArticleLayout, LazyCategoryLayout, LazyDefaultLayout, LazyArticleAuthor, LazyCtaWidget, LazyCategoryAlternativeCard, LazyHomeSection, LazyHomeSectionContent, LazyUBreadcrumbs, LazyUBtn, LazyUBtnGroup, LazyUFeatureCard, LazyUInfoCard, LazyUEmbedded, LazyUExpansionPanel, LazyUFrame, LazyUIcon, LazyUIllustration, LazyULink, LazyULogo, LazyUPagination, LazyUSelect, LazyUSlider, LazyUText, LazyUTextField, LazyUContent, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["PageTitle", LazyPageTitle],
["UTable", LazyUTable],
["Faq", LazyFaq],
["UBanner", LazyUBanner],
["UHighlight", LazyUHighlight],
["USummaryCard", LazyUSummaryCard],
["UVideo", LazyUVideo],
["CompoundCalculator", LazyCompoundCalculator],
["PensionCalculator", LazyPensionCalculator],
["ArticleLayout", LazyArticleLayout],
["CategoryLayout", LazyCategoryLayout],
["DefaultLayout", LazyDefaultLayout],
["ArticleAuthor", LazyArticleAuthor],
["CtaWidget", LazyCtaWidget],
["CategoryAlternativeCard", LazyCategoryAlternativeCard],
["HomeSection", LazyHomeSection],
["HomeSectionContent", LazyHomeSectionContent],
["UBreadcrumbs", LazyUBreadcrumbs],
["UBtn", LazyUBtn],
["UBtnGroup", LazyUBtnGroup],
["UFeatureCard", LazyUFeatureCard],
["UInfoCard", LazyUInfoCard],
["UEmbedded", LazyUEmbedded],
["UExpansionPanel", LazyUExpansionPanel],
["UFrame", LazyUFrame],
["UIcon", LazyUIcon],
["UIllustration", LazyUIllustration],
["ULink", LazyULink],
["ULogo", LazyULogo],
["UPagination", LazyUPagination],
["USelect", LazyUSelect],
["USlider", LazyUSlider],
["UText", LazyUText],
["UTextField", LazyUTextField],
["UContent", LazyUContent],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
